import { gql } from '@apollo/client'
import type { TypedDocumentNode } from '@graphql-typed-document-node/core'

import type {
    AttendEventWithoutAccountMutation,
    AttendEventWithoutAccountMutationVariables,
} from './AddAttendee.mutations.generated'

export const FORCE_ADD_ATTENDEE: TypedDocumentNode<
    AttendEventWithoutAccountMutation,
    AttendEventWithoutAccountMutationVariables
> = gql`
    mutation AttendEventWithoutAccount(
        $input: attendEventWithoutAccountInput!
    ) {
        attendEventWithoutAccount(input: $input) {
            entity {
                guid
                ... on Event {
                    attendees(
                        limit: 3
                        state: "accept"
                        orderBy: timeUpdated
                        orderDirection: desc
                    ) {
                        total
                        totalAccept
                        totalMaybe
                        totalOnline
                        totalReject
                        totalWaitinglist
                        edges {
                            guid
                            name
                            state
                            url
                            icon
                        }
                    }
                }
            }
        }
    }
`
